Service = App.loadClass 'core::Angular/Service'

class exports.ReportService extends Service

    constructor: (@http, @window) ->
        return

    getYearsAndSpps: () =>
        return @http.post('backend/grower/placement/report/get-years-and-spps')

    getSurveyResults: (years, spps) =>
        params =
            years: years
            spp_ids: spps.map (spp) -> spp.id

        return @http.post('backend/grower/placement/report/get-survey-results', params)

    getDuplicateFields: (survey_results) =>
        params =
            survey_result_ids: survey_results.map (survey_result) -> survey_result.id

        return @http.post('backend/grower/placement/report/get-duplicate-fields', params)

    getPlanDetails: (survey_result, field) =>
        params =
            survey_result_id: survey_result.id
            field_id: field.id

        return @http.post('backend/grower/placement/report/get-plan-details', params)

    getSurveyDetails: (survey_result, field) =>
        params =
            survey_result_id: survey_result.id
            field_id: field.id

        return @http.post('backend/grower/placement/report/get-survey-details', params)

    launchPsr: (selections, ui) =>
        # Update UI
        ui.loading = true
        ui.buttonText = 'Generating Report...'

        params =
            layer_ids_by_year: @_getLayerIdsFromSelections(selections)
            send_email: true
        selections.downloading = true
        @http.post('backend/grower/placement/report/generate-psr', params).then (result) =>
            # Update UI
            selections.downloading = false
            ui.loading = false
            ui.buttonText = 'Next'

            # TODO: add error handling

            # launch the PDF in a new tab
            response = result.data
            params = $.param
                file: response.data.file
                file_name: response.data.file_name
            @window.open("backend/grower/placement/report/show-psr?#{params}")
        , () ->
            # if the request fails
            selections.downloading = false

    _getLayerIdsFromSelections: (selections) =>
        layer_ids_by_year = {}
        for sr in selections.survey_results
            for field_id, layer_id of sr.planned_fields
                # check if the field is a duplicate (use parseInt because the
                # field_id is an object key, so it's a string)
                dup = _.find(selections.duplicate_fields, id: parseInt(field_id))
                if dup?
                    # if the field is a duplicate, we only add the layer if the
                    # survey result was selected, or if there were no survey
                    # results selected for the field (i.e. include duplicates).
                    arr = dup.survey_results[sr.year]
                    if not arr? or sr in arr or arr.length is 0
                        layer_ids_by_year[sr.year] ?= []
                        layer_ids_by_year[sr.year].push(layer_id)
                else
                    # if the field isn't a duplicate, add the layer, of course
                    layer_ids_by_year[sr.year] ?= []
                    layer_ids_by_year[sr.year].push(layer_id)

        return layer_ids_by_year
